import React from "react";
import { Link } from "react-router-dom";

/**
 * Shown when the API refuses a property or company with 403 (bug 4020): the item exists
 * but belongs to a company the user is not linked to. Says so plainly and offers a way back,
 * rather than leaving an empty screen.
 */
export const AccessDeniedNotice = ({
  resource = "property",
}: {
  resource?: "property" | "company";
}) => (
  <div
    role="alert"
    data-testid="access-denied-notice"
    className="mx-auto my-10 max-w-xl rounded-lg border border-gray-200 bg-white p-6 text-center shadow-sm"
  >
    <h2 className="text-lg font-semibold text-gray-900">
      You don't have access to this {resource}
    </h2>
    <p className="mt-2 text-sm text-gray-600">
      It belongs to a company you are not linked to. If you think you should have access,
      ask an administrator to add you to that company.
    </p>
    <Link
      to="/portfolio"
      className="mt-4 inline-block rounded bg-zeos-orange-dk px-4 py-2 text-sm text-white"
    >
      Back to your portfolio
    </Link>
  </div>
);
